import * as React from 'react';
import { Button } from '@cian/ui-kit/button';
import { Heart16, HeartStroke16 } from '@cian/ui-kit/icons';
import { IFavoriteButtonProps } from '../../../types/newbuilding/favorite';

export function HeartFavoriteSecondaryButton({ isFavorite, onClick }: IFavoriteButtonProps) {
  const icon = isFavorite ? <Heart16 color="error_100" /> : <HeartStroke16 color="error_100" />;

  return <Button theme="fill_secondary" onClick={onClick} beforeIcon={icon} size="XS" />;
}
